import { ZepIcon_default } from './chunk-SGEFWXJL.mjs';
import { jsxs, jsx } from 'react/jsx-runtime';

var BoltFillColorMintIcon = ZepIcon_default(
  (props) => /* @__PURE__ */ jsxs("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...props, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.31 2.05A1 1 0 0 1 14 3v6h5a1 1 0 0 1 .809 1.588l-8 11A1 1 0 0 1 10 21v-6H5a1 1 0 0 1-.809-1.588l8-11a1 1 0 0 1 1.118-.363Z",
        fill: "url(#paint0_linear_422_29)"
      }
    ),
    /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs(
      "linearGradient",
      {
        id: "paint0_linear_422_29",
        x1: 4,
        y1: 12,
        x2: 20,
        y2: 12,
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ jsx("stop", { stopColor: "#18D0B4" }),
          /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#3CD84C" })
        ]
      }
    ) })
  ] })
);

export { BoltFillColorMintIcon };
